import React from 'react'
import LinkTreeItemHistory from './LinkTreeItemHistory'
import LinkTreeItemLink from './LinkTreeItemLink'

const LinkTreeItemSection = ({ item, index, isLast, isTheOnlyOne }) => {
  const isPublicHistory = item?.configuration?.isPublicHistory

  if (!isPublicHistory)
    return <LinkTreeItemLink item={item} index={index} isLast={isLast} isTheOnlyOne={isTheOnlyOne} />

  return <LinkTreeItemHistory item={item} index={index} isLast={isLast} isTheOnlyOne={isTheOnlyOne} />
}

export default LinkTreeItemSection
